import { Component, OnInit, effect, inject } from '@angular/core';
import {} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import {
  CustomResultOfOutboxMessageNumbersWithPaginationDto,
  OutboxMessageNumbersWithPaginationDto,
  OutboxMessageNumbersWithPaginationItem,
} from 'src/app/core/api/models';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { DefaultSearchValueService } from 'src/app/core/services/default-search-value.service';
import { ScheduledMessageIdsStorageService } from 'src/app/core/services/scheduled-message-ids-storage.service';
import { OutboxMessageNumbersService } from '../../../../core/api/services/outbox-message-numbers.service';
import { FileService } from '../../../../core/services/file.service';
import { SendReceiversComponent } from '../send-receivers/send-receivers.component';
import { ExcelService as excelFileService } from './../../../../core/api/services';

@Component({
  selector: 'app-dynamic-send-receivers',
  templateUrl: './dynamic-send-receivers.component.html',
  styleUrls: ['./dynamic-send-receivers.component.scss'],
  standalone: false,
})
export class DynamicSendReceiversComponent
  extends SendReceiversComponent
  implements OnInit
{
  appStateService = inject(AppStateService);
  //#region Properties
  modelWithPagination$: Observable<OutboxMessageNumbersWithPaginationDto>;
  items$: Observable<Array<OutboxMessageNumbersWithPaginationItem>>;
  mciImage: string;
  rightelImage: string;
  //#endregion

  constructor(
    protected currentService: OutboxMessageNumbersService,
    protected sanitizer: DomSanitizer,
    protected fileService: FileService,
    protected translate: TranslateService,
    protected excelFileService: excelFileService,
    protected scheduledMessageIdsStorageService: ScheduledMessageIdsStorageService,
    protected defaultSearchValueService: DefaultSearchValueService
  ) {
    super(
      currentService,
      sanitizer,
      fileService,
      translate,
      excelFileService,
      scheduledMessageIdsStorageService,
      defaultSearchValueService
    );
    effect(() => {
      this.mciImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/mci-dark.svg'
          : '/assets/media/svg/operator/mci.svg';
      this.rightelImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/rightel-dark.svg'
          : '/assets/media/svg/operator/rightel.svg';
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.tableConfig.showOperationColumn = false;
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs;

    this.tableColumns = [
      //checkbox
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      // smsText
      { title: `common.smsText`, name: 'smsText', hasSearch: true },
      // smsParts
      {
        title: `common.smsParts`,
        name: 'smsParts',
        hasSearch: true,
        type: 'number',
      },
      // topNumber
      {
        title: `${this.tableVocabs}toNumber`,
        name: 'toNumber',
        hasSearch: true,
      },
      // mobileOperator
      {
        title: `common.operator`,
        name: 'mobileOperator',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsAggregator',
      },
      // sendStatus
      {
        title: `${this.tableVocabs}sendStatus`,
        name: 'SendStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'SendStatus',
      },
      //deliveryStatus
      {
        title: `${this.tableVocabs}deliveryStatus`,
        name: 'DeliveryStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'DeliveryStatus',
      },
      //statusDateTime
      { title: `${this.tableVocabs}statusDateTime`, name: 'statusDateTime' },
      // {
      //   title: `${this.tableVocabs}sendDateTime`,
      //   name: 'sendDateTime',
      //   hasSearch: true,
      //   dateDefaultValue: this.defaultSearchValueService.defaultDateValue,
      //   isRequired: true,
      //   type: 'date',
      //   wrap: true,
      // },
    ];

    if (this.isSmartType)
      this.tableColumns = this.tableColumns.filter(
        (column) => column.name !== 'toNumber'
      );
  }

  //#region Api

  getPaginationApi(): Observable<CustomResultOfOutboxMessageNumbersWithPaginationDto> {
    if (
      this.pageConfig.tableConfig.paginationModel.pageSize >
      this.pageConfig.tableConfig.paginationModel.totalCount
    )
      this.pageConfig.tableConfig.paginationModel.pageNumber = 1;

    return this.currentService.outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          scheduledMessageId: this.scheduledMessageId,
        },
      }
    );
  }
  //#endregion
}
